export const SETTING_GROUPS = {
    MASTER: {
        title: 'Master Security Control',
        icon: '🛡️',
        settings: [
            {
                key: 'turn_off_fpe',
                title: 'Fraud Prevention Engine (FPE)',
                description: 'Master switch that controls ALL security checks. When ON, security features work according to their individual settings. When OFF, all security checks are completely disabled.',
                apiMethods: { enable: 'turn_on_fpe', disable: 'turn_off_fpe' },
                isMaster: true,
                invertLogic: true // This tells us to invert the boolean logic
            }
        ]
    },
    SECURITY: {
        title: 'Individual Security Checks',
        icon: '🔍',
        dependsOn: 'turn_off_fpe',
        settings: [
            {
                key: 'check_camera',
                title: 'Virtual Camera Detection',
                description: 'Detect and block virtual cameras, screen recordings, and other spoofing attempts during live verification',
                apiMethods: { enable: 'enable_check_camera', disable: 'disable_check_camera' }
            },
            // {
            //     key: 'check_camera_strict',
            //     title: 'Strict Camera Detection',
            //     description: 'Enhanced virtual camera detection with stricter validation rules',
            //     apiMethods: { enable: 'enable_check_camera_strict', disable: 'disable_check_camera_strict' }
            // },
            // {
            //     key: 'check_camera_window_switch',
            //     title: 'Window Switch Detection',
            //     description: 'Detect when users switch between windows or applications during verification',
            //     apiMethods: { enable: 'enable_check_camera_window_switch', disable: 'disable_check_camera_window_switch' }
            // },
            {
                key: 'check_fhaa',
                title: 'Face Database Check (FHAA)',
                description: 'Check if the person\'s face is already associated with another account to prevent duplicate registrations',
                apiMethods: { enable: 'enable_fhaa', disable: 'disable_fhaa' }
            },
            // {
            //     key: 'check_pth',
            //     title: 'Person-to-Human Check (PTH)',
            //     description: 'Verify that the person being verified is a real human and not an AI-generated image or deepfake',
            //     apiMethods: { enable: 'enable_pth', disable: 'disable_pth' }
            // }
        ]
    },
    DEVICE: {
        title: 'Device & Access Control',
        icon: '🖥️',
        dependsOn: 'turn_off_fpe',
        settings: [
            {
                key: 'reject_desktop',
                title: 'Desktop Verification Blocking',
                description: 'Block users from completing verification processes on desktop computers and laptops (mobile only)',
                apiMethods: { enable: 'enable_reject_desktop', disable: 'disable_reject_desktop' }
            }
        ]
    },
    GEOGRAPHIC: {
        title: 'Geographic Access Control',
        icon: '🌍',
        dependsOn: 'turn_off_fpe',
        settings: [
            {
                key: 'allowed_countries',
                title: 'Country-based Access Control',
                description: 'Restrict verification access based on user\'s geographic location and IP address. When enabled, only selected countries will be allowed.',
                apiMethods: { enable: 'enable_country_blocking', disable: 'disable_country_blocking' },
                hasChildren: true
            }
        ]
    },
    // ADVANCED: {
    //     title: 'Advanced Features',
    //     icon: '⚡',
    //     dependsOn: 'turn_off_fpe',
    //     settings: [
    //         {
    //             key: 'green_lane',
    //             title: 'Green Lane Processing',
    //             description: 'Enable fast-track processing for low-risk users with simplified verification steps',
    //             apiMethods: { enable: 'enable_green_lane', disable: 'disable_green_lane' }
    //         }
    //     ]
    // }
};
